/*
  GM — Il conto del carrello che si ricalcola da solo.

  Il contenuto lo disegna Liquid (snippets/gm-conto.liquid): qui non si somma
  e non si formatta nessun importo. A ogni cambio del carrello si richiede la
  sezione gm-conto-carrello e ogni <gm-conto> prende il suo pezzo, «testa» o
  «riepilogo». Una richiesta sola per tutti e due.
*/
import Cart from "cart-store";

const SEZIONE = "gm-conto-carrello";
let richiesta = null;
let richiestaV = -1;
/* Ogni cambio del carrello ha il suo numero: una risposta chiesta per uno
   stato piu' vecchio non si riusa e non si applica (due + ravvicinati
   lasciavano il conto fermo sul totale di prima). */
let versione = 0;
Cart.subscribe((s, prima) => { if (s.cart !== prima.cart) versione += 1; });

function radice() {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
}

function prendiSezione() {
  if (!richiesta || richiestaV !== versione) {
    richiestaV = versione;
    /* Una richiesta che non torna piu' (4G di campagna, anti-bot di Shopify)
       lasciava il conto sbiadito per sempre: dopo 8 secondi si taglia. */
    const ctrl = new AbortController();
    const orologio = setTimeout(() => ctrl.abort(), 8000);
    const p = fetch(radice() + "?sections=" + SEZIONE, { cache: "no-store", signal: ctrl.signal, headers: { Accept: "application/json" } })
      .then((r) => {
        if (!r.ok) throw new Error(SEZIONE + " " + r.status);
        return r.json();
      })
      .then((j) => (j && j[SEZIONE]) || "")
      .finally(() => { clearTimeout(orologio); });
    richiesta = p;
    const libera = () => { setTimeout(() => { if (richiesta === p) richiesta = null; }, 0); };
    p.then(libera, libera);
  }
  return richiesta;
}

/* Quando il tema ridisegna una riga la ricrea dal suo <template>, che non sa
   niente della variante scritta accanto al nome: qui la si rimette, leggendola
   dall'elemento che il tema riempie da se' (nascosto dal foglio del carrello).
   Stesso giro per «Articolo / Articoli» in testa all'elenco. */
/* Il cestino non ha nome: l'icona e' aria-hidden, quindi lo screen reader
   legge solo «link» o l'indirizzo. L'etichetta base la mette lo snippet; qui
   si aggiunge il nome dell'articolo alle righe che il tema ricrea dal suo
   <template>, dove il titolo nasce vuoto. */
function gmNomeCestino(riga) {
  const via = riga.querySelector("[cart-item-remove]");
  const t = riga.querySelector("cart-item-title");
  if (!via || !t) return;
  const nome = t.textContent.trim();
  const base = (via.getAttribute("aria-label") || "").split(":")[0].trim();
  if (base && nome) via.setAttribute("aria-label", base + ": " + nome);
}

function rifinisciRighe() {
  const righe = document.querySelectorAll(".cart--page cart-item");
  righe.forEach((riga) => {
    gmNomeCestino(riga);
    const titolo = riga.querySelector(".cart-item__heading");
    const prop = riga.querySelector("cart-item-default-property");
    gmGruppoQta(riga);
    if (!titolo || !prop) return;
    const testo = prop.textContent.trim();
    let span = titolo.querySelector(".gmci__var");
    if (!testo) { if (span) span.remove(); return; }
    if (!span) {
      span = document.createElement("span");
      span.className = "gmci__var";
      titolo.appendChild(span);
    }
    span.textContent = "\u00a0/\u00a0" + testo;
  });
  const et = document.querySelector(".cart--page [data-gm-et]");
  if (et && righe.length) et.textContent = righe.length === 1 ? et.dataset.uno : et.dataset.piu;
}

/* «Quantita'», «+» e «−» si chiamano uguale su ogni riga: il contesto si da'
   una volta sola sul contenitore. Le righe disegnate da Liquid ce l'hanno
   gia' dallo snippet; queste sono quelle ricreate dal <template>, dove il
   titolo nasce vuoto. */
function gmGruppoQta(riga) {
  const qi = riga.querySelector("quantity-input");
  const t = riga.querySelector("cart-item-title");
  if (!qi || !t || qi.getAttribute("aria-label")) return;
  const campo = qi.querySelector("input");
  const nome = t.textContent.trim();
  if (!campo || !nome) return;
  qi.setAttribute("role", "group");
  qi.setAttribute("aria-label", (campo.getAttribute("aria-label") || "") + ": " + nome);
}

class GmConto extends HTMLElement {
  connectedCallback() {
    this._sub = Cart.subscribe((s, prima) => {
      if (s.cart !== prima.cart) this.pianifica();
    });
    /* Uscito da un <template> (carrello che da vuoto diventa pieno) il conto
       e' quello del caricamento della pagina: va richiesto subito. */
    if (!this.hasAttribute("data-pronto")) this.pianifica(0);
  }

  disconnectedCallback() {
    if (this._sub) { this._sub(); this._sub = null; }
    clearTimeout(this._t);
  }

  pianifica(ms) {
    clearTimeout(this._t);
    /* subito, e di nuovo a conto arrivato: il tema ridisegna le righe nello
       stesso giro in cui avvisa del cambio. */
    requestAnimationFrame(rifinisciRighe);
    this.setAttribute("aria-busy", "true");
    this._t = setTimeout(() => this.carica(), ms === undefined ? 120 : ms);
  }

  async carica(tentativo) {
    const v = versione;
    const n = tentativo || 0;
    let html;
    try { html = await prendiSezione(); }
    catch (e) {
      /* Questo e' l'unico totale a video: lasciare le cifre di prima a piena
         opacita' sarebbe dire una bugia, perche' le righe intanto sono
         cambiate. Si riprova due volte e, se non arriva niente, il conto
         resta sbiadito — che e' la verita': non e' aggiornato. Niente
         ricaricamento della pagina: se e' la rete ad aver fatto fallire la
         fetch, una navigazione fallisce allo stesso modo e il cliente perde
         il carrello invece di vederlo sbiadito. Al primo cambio successivo
         il subscribe fa ripartire il giro da solo. */
      if (v !== versione) return;
      if (n < 2) { this._t = setTimeout(() => this.carica(n + 1), 1500 * (n + 1)); }
      return;
    }
    /* il carrello e' cambiato ancora mentre si aspettava: il giro nuovo e'
       gia' pianificato dal subscribe */
    if (v !== versione) return;
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    const pezzo = tmp.querySelector('[data-gm-conto="' + (this.dataset.modo || "riepilogo") + '"]');
    const corpo = pezzo && pezzo.querySelector("[data-gm-conto-corpo]");
    /* si sostituisce SOLO il corpo: le icone di pagamento, che la pagina
       stampa una volta sola, sono un fratello e restano dove sono. */
    if (corpo) {
      const vecchio = this.querySelector("[data-gm-conto-corpo]");
      if (vecchio) vecchio.replaceWith(corpo);
      else this.prepend(corpo);
    }
    rifinisciRighe();
    /* Chi non vede il conto cambiare deve sentirselo dire: spedizione e totale
       nuovi finiscono nella regione live della pagina. Parla solo il riepilogo,
       che c'e' sempre: due <gm-conto> direbbero la stessa cifra due volte. */
    if ((this.dataset.modo || "riepilogo") === "riepilogo") {
      const voce = document.querySelector("[data-gm-annuncio]");
      if (voce) {
        voce.textContent = Array.from(this.querySelectorAll(".gmct__riga--sped, .gmct__riga--tot"))
          .map((r) => r.textContent.replace(/\s+/g, " ").trim())
          .join(". ");
      }
    }
    this.setAttribute("data-pronto", "");
    this.removeAttribute("aria-busy");
  }
}

if (!customElements.get("gm-conto")) {
  customElements.define("gm-conto", GmConto);
}

/* Tasto indietro (e il gesto di iOS): il browser puo' ripristinare la pagina
   dalla sua cache — righe, kit e conto com'erano — anche se nel frattempo il
   carrello e' cambiato, per esempio componendo il kit dalla scheda prodotto.
   Il carrello vero sta sul server: si rilegge, e da li' righe, conto e kit si
   ridisegnano da soli. Su una visita normale «persisted» e' falso e non
   succede niente. */
window.addEventListener("pageshow", (e) => {
  if (e.persisted) Cart.refresh().catch(() => {});
});
